export default __webpack_public_path__ + "static/media/QDOS.79d7091f.png";